export default __webpack_public_path__ + "static/media/tasks-green.24ae8422.svg";